import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-paygreen-lunchr',
  templateUrl: './payment-panel-paygreen-lunchr.component.html',
})
export class PaymentPanelPaygreenLunchrComponent {}
